module.exports = __webpack_public_path__ + "img/mini-app-quiz.2319bcef.jpg";